import React from "react";
import { useLang } from "../context/LangContext";
import useDocumentTitle from "../hooks/useDocumentTitle";
import InfoLayout from "../components/InfoLayout";

export default function AuthorPage() {
  const { t } = useLang();
  useDocumentTitle(t("Sobre o autor · ReiMultiBlog", "About the author · ReiMultiBlog"),
    t("Quem está por trás do ReiMultiBlog.", "Who is behind ReiMultiBlog."));
  return (
    <InfoLayout title={t("Sobre o autor", "About the author")} crumb={t("Sobre o autor", "About the author")}
      subtitle={t("Quem partilha estas experiências.", "Who shares these experiences.")}>
      <div className="flex items-center gap-4 not-prose mb-6">
        <img src="/logo.png" alt="ReiMultiBlog" className="h-16 w-16 object-contain" />
        <div>
          <div className="text-white font-semibold text-lg">Nelson · ReiMultiBlog</div>
          <div className="text-sm text-muted-foreground">grouprei.com</div>
        </div>
      </div>
      <p>{t(
        "Sou o autor por trás do ReiMultiBlog. Partilho aqui aquilo que aprendo na prática — desde a vida e a burocracia na Suíça, até ao desenvolvimento de software e à automação de tarefas do dia a dia.",
        "I'm the author behind ReiMultiBlog. Here I share what I learn hands-on — from life and bureaucracy in Switzerland to software development and everyday task automation.")}</p>
      <p>{t(
        "Cada artigo nasce de experiências, testes e projetos reais, com o objetivo de poupar tempo a quem passa pelos mesmos desafios.",
        "Every article comes from real experiences, tests and projects, aiming to save time for those facing the same challenges.")}</p>
    </InfoLayout>
  );
}
